import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@app/shared/services/properties/properties.service';

@Pipe({
  standalone: false,
  name: 'listBookingListingsRoomIds',
})
export class ListBookingListingsRoomIdsPipe implements PipeTransform {
  transform(property: Property): string {
    const roomIds = [];

    property.listings.forEach((listing) => {
      if (listing.platform_key === 'booking') {
        roomIds.push(listing.listing_id);
      }
    });

    return roomIds.join(', ');
  }
}
